// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HFfAw","content":"styles_content__2vRg0"};